import useSilentGps from '../hooks/useVisitaTracking';

import { useCart } from '../context/CartContext';

import { useVendor } from '../context/VendorContext';



/**

 * Tracker GPS silencioso (invisible_total): sin diálogos ni barras.

 * Horario laboral o visita/pedido abiertos; admin ve la ruta.

 */

export default function SilentVisitaTracker() {

  const { vendedor } = useVendor();

  const { state } = useCart();

  const { cliente, items } = state;



  const visitaAbierta = Boolean(cliente.visita_id && !cliente.visita_fin);

  const pedidoEnCurso = Boolean(

    visitaAbierta ||

      (cliente.sucursal_id && (items?.length > 0 || cliente.visita_inicio))

  );

  const visitaId = visitaAbierta ? cliente.visita_id : null;



  useSilentGps({

    vendedorId: vendedor?.id || null,

    visitaId,

    forceActive: pedidoEnCurso,

  });



  return null;

}


